let GeoCurrency = {
    // We get the geolocation of the client
    getGeo: function(){
        if(this.checkNewCustomer()){
            $.ajax({
                url: "https://get.geojs.io/v1/ip/geo.js",
                dataType: "jsonp",
                jsonpCallback:"geoip",
                success: function(data) {
                  GeoCurrency.chooseСurrency(data.country,data.country_code);
                }
              });
        }else{
            return false;
        }
        
    },

    chooseСurrency: function(country, country_code) {
        let currencies;
        
        if(country == 'United Arab Emirates' || country_code == 'AE' || country == 'Saudi Arabia' || country_code == 'SA' || country == 'Qatar' || country_code == 'QA' || country == 'Oman' || country_code == 'OM' || country == 'Kuwait' || country_code == 'KW' || country == 'Bahrain' || country_code == 'BH'){
            currencies = 'AED';
        }else if(country == 'Germany' || country_code == 'DE' || country == 'France' || country_code == 'FR'  || country == 'Georgia' || country_code == 'GE' || country == 'Italy' || country_code == 'IT' || country == 'Spain' || country_code == 'ES'){
            currencies = 'EUR';
        }else if(country == 'United Kingdom' || country_code == 'GB'){
            currencies = 'GBP';
        }else{
            currencies = 'EUR';
        }
        console.log(country, country_code);
        console.log(currencies);
        
        
        this.changeCurrency(currencies);
        
    },
    checkNewCustomer: function(){
        let newCustomer;

        if(localStorage.getItem('visiting') == null){
            newCustomer = true;
            localStorage.setItem('visiting' , true);
        }else{
            newCustomer = false;
        }
        console.log('New Customer - '+newCustomer);
        return newCustomer;
    },
    changeCurrency: function(currency){
        select_currencies_update(undefined,currency);
       
        console.log('Change currency -' + currency);
    }
}

GeoCurrency.getGeo();